const boxEndpoint = process.env.REACT_APP_BOX_API;
const accountsEndpoint = process.env.REACT_APP_ACCOUNTS_API;
const userEndpoint = process.env.REACT_APP_USER_API;
const hermesEndpoint = process.env.REACT_APP_HERMES_API;
const aceEndpoint = process.env.REACT_APP_ACE_API;
const cfURL = process.env.REACT_APP_CF_URL;
const envURL = process.env.REACT_APP_ENV_URL;
const originURL = process.env.REACT_APP_ORIGIN_URL;
const erosURL = process.env.REACT_APP_EROS_S3_URL;
const loginVerifyEndpoint = process.env.REACT_APP_LOGIN_VERIFY_API;
const mysteryBoxFilename = process.env.REACT_APP_MYSTERY_BOX_FILENAME;
const ldKey = process.env.REACT_APP_LDKEY;
const questionnaireEndpoint = process.env.REACT_APP_QUESTIONNAIRE_API_URL;
const replenishmentEndpoint = process.env.REACT_APP_REPLENISHMENT_API_URL;
const growthEndpoint = process.env.REACT_APP_GROWTH_API_URL;
const loginUrl = process.env.REACT_APP_LOGIN_URL;
const env = process.env.REACT_APP_ENV;
const appliedLabsChatbotAgentId = process.env.REACT_APP_APPLIED_LABS_AGENT_ID;
const storefrontEndpoint = process.env.REACT_APP_STOREFRONT_API_URL;

export default {
  box: boxEndpoint,
  accounts: accountsEndpoint,
  user: userEndpoint,
  hermes: hermesEndpoint,
  ace: aceEndpoint,
  cfURL,
  envURL,
  originURL,
  erosURL,
  loginVerify: loginVerifyEndpoint,
  mysteryBoxFilename,
  ldKey,
  questionnaire: questionnaireEndpoint,
  replenishment: replenishmentEndpoint,
  growth: growthEndpoint,
  loginUrl,
  env,
  appliedLabsChatbotAgentId,
  storefront: storefrontEndpoint,
};
